import _Object$assign from 'babel-runtime/core-js/object/assign';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import DialogForm from '@/components/DialogForm/index.vue';
import PreviewItem from './previewItem.vue';
import VideoUploader from '@/views/repository/material/video/videoUploader.vue';
import { repositoryName, cat1Options, cat2Options } from '@/views/repository/config';
import { cookOptions, filterOption } from '@/utils/option';
import NineGrid from '@/components/PatchDialog/nine-grid.vue';
import { animationType, animationTag } from '@ps/utils/config';

export default {
  components: {
    DialogForm: DialogForm,
    // eslint-disable-next-line vue/no-unused-components
    PreviewItem: PreviewItem,
    // eslint-disable-next-line vue/no-unused-components
    VideoUploader: VideoUploader
  },
  props: {
    /**
     * 资源类型，与后端的type值为准
     * 5: 视频，6: 音乐，7: 手指， 8: 背景图， 9: 按钮皮肤，
     * 10: 特效，11: 主角，12: 文案，13: 图片
     */
    resourceType: {
      type: Number,
      default: 0,
      required: true
    },
    uploadData: {
      type: [Object, Function],
      default: function _default() {}
    },
    /**
     * 对组件中的radio选择项做过滤
     */
    optionsFilter: {
      type: Object,
      default: function _default() {}
    },
    /**
     * 是否自定义组件内部的上传回调
     */
    customUploadSuccess: {
      type: Boolean,
      defalut: false
    },

    costomBeforeUpload: {
      type: Function,
      default: function _default() {
        return true;
      }
    }
  },
  data: function data() {
    return {
      editType: 0, // 操作类型：0: 新增，1: 编辑
      config: {
        visible: false,
        title: '',
        loading: false
      },
      formConfig: {
        labelPosition: 'left',
        labelWidth: '120px'
      },
      value: {
        id: '',
        name: '',
        name_en: '',
        message: '',
        file_type: 'local',
        file_path: '',
        image_url: '',
        preview_urls: '',
        tag_ids: [],
        cat1_id: 1,
        cat2_id: 1,
        dimension: '',
        ext_config: '{}',
        file: {}, // 放置上传后后端返回的file内容
        res_type: this.resourceType
      },
      oldValue: {}, // 保存旧数据，判断如果不存在改动则直接return
      fileList: [],
      cat2Options: cat2Options,
      cat1Options: cat1Options
    };
  },

  watch: {
    'config.visible': function configVisible(val) {
      if (val === false) {
        if (this.config.loading) {
          this.close();
        }
        this.$emit('close');
      }
    },
    'value.cat1_id': function valueCat1_id(val) {
      if (Number(this.resourceType) === 18) {
        if (this.innerAnimationTag.map(function (item) {
          return item.value;
        }).indexOf(this.value.cat2_id) === -1) {
          this.value.cat2_id = '';
        }
      }
    },
    dialogTitle: function dialogTitle(val) {
      this.config.title = val;
    },
    resourceType: function resourceType(val) {
      this.value.res_type = val;
    },
    'value.file_path': function valueFile_path(val) {
      if (val) {
        this.$refs.form.validateField('file_path');
      }
    },
    'value.tag_ids': function valueTag_ids(val) {
      if (!this.config.visible) return;
      if (val && val.length) {
        this.$refs.form.validateField('tag_ids');
      }
    }
  },
  computed: {
    isEffect: function isEffect() {
      return Number(this.resourceType) === 10;
    },
    isLeadRole: function isLeadRole() {
      return Number(this.resourceType) === 11;
    },
    isSlogan: function isSlogan() {
      return Number(this.resourceType) === 12;
    },
    isVideo: function isVideo() {
      return Number(this.resourceType) === 5;
    },

    // 是否显示标签项，兼容旧交互素材没有标签
    tagShow: function tagShow() {
      if (this.isSlogan) return false; // 文案没有标签
      // if (this.isEffect && this.value.cat2_id === 2) return false // 特效库中展示特效没有标签
      if (Number(this.resourceType) === 16 || Number(this.resourceType) === 18) return false;
      return true;
    },
    libName: function libName() {
      var _this = this;

      return (repositoryName.find(function (e) {
        return e.value === Number(_this.resourceType);
      }) || {}).label;
    },
    dialogTitle: function dialogTitle() {
      if (this.editType === 1) return '编辑' + this.libName;
      return '添加' + this.libName;
    },

    // 返回表单内容是否显示的对象
    dialogItemVisible: function dialogItemVisible() {
      return {
        id: !!this.editType, // 编辑的时候才显示
        name: !this.isSlogan, // 文案模式没有名称输出框
        name_en: !this.isSlogan && [6, 7, 8, 9, 10, 14, 15, 16, 17, 18].includes(this.resourceType), // 文案模式和非模型、动作和2D动画没有名称输出框
        message: this.isSlogan, // 只有文案模式需要message
        cat2_id: !this.editType && this.isEffect || this.resourceType === 18, // 非编辑模式的特效类型才有cat2_id
        cat1_id: !this.editType && (this.isEffect || this.isLeadRole) || this.resourceType === 18, // 非编辑模式的特效类型/主角类似才有cat1_id
        file_path: !this.isSlogan && this.config.visible, // 非文本模式都有上传/预览组件，为了保证每次渲染都是新组件，需要与dialog的visible双向绑定
        tag_ids: this.tagShow,
        access_allow_pt: !!this.editType && [6, 7, 8, 9, 10, 14, 15, 16, 17, 18].includes(this.resourceType)
      };
    },
    dialogItem: function dialogItem() {
      var _this2 = this;

      // 当resouceType没有值的时候或者dialog隐藏的时候，没有组件
      if (!this.resourceType || !this.config.visible) return [];
      return [{
        visible: this.dialogItemVisible.id,
        label: 'ID：',
        type: 'plain-text',
        prop: 'id'
      }, {
        visible: this.dialogItemVisible.name,
        label: this.libName + '名称：',
        type: 'input',
        prop: 'name',
        rules: [{
          required: true,
          message: '请输入' + this.libName + '名称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: this.libName + '名称不能超过 100 个字符',
          trigger: 'blur'
        }]
      }, {
        visible: this.dialogItemVisible.name_en,
        label: this.libName + '英文名称：',
        type: 'input',
        prop: 'name_en',
        rules: [{
          required: true,
          message: '请输入' + this.libName + '英文名称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: this.libName + '英文名称不能超过 100 个字符',
          trigger: 'blur'
        }]
      }, {
        visible: this.dialogItemVisible.message,
        label: this.libName + '内容：',
        type: 'input',
        subtype: 'textarea',
        prop: 'message',
        rules: [{
          required: true,
          message: '请输入' + this.libName + '内容',
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: this.libName + '内容不能超过 500 个字符',
          trigger: 'blur'
        }]
      }, {
        visible: this.dialogItemVisible.cat1_id,
        label: this.resourceType === 18 ? '动画分类' : this.libName + '实现方式：',
        type: this.resourceType === 18 ? 'select' : 'radio-group',
        prop: 'cat1_id',
        params: function params(_ref) {
          var formValue = _ref.formValue;

          return {
            options: _this2.resourceType === 18 ? animationType : _this2.filteredCat1Options,
            button: false,
            border: true
          };
        },
        rules: [{
          required: true,
          message: '请选择' + this.libName + '实现方式',
          trigger: 'change'
        }]
      }, {
        visible: this.dialogItemVisible.cat2_id,
        label: this.resourceType === 18 ? '效果分类' : this.libName + '类型：',
        type: this.resourceType === 18 ? 'select' : 'radio-group',
        prop: 'cat2_id',
        params: function params(_ref2) {
          var formValue = _ref2.formValue;

          return {
            options: _this2.resourceType === 18 ? _this2.innerAnimationTag : _this2.filteredCat2Options,
            button: false,
            border: true
          };
        },
        rules: [{
          required: true,
          message: '请选择' + this.libName + '类型',
          trigger: 'change'
        }]
      }, {
        // 确保每次渲染都是新组件
        visible: this.dialogItemVisible.file_path,
        label: this.libName + '文件：',
        type: this.isVideo || this.editType ? '' : 'business', // 视频与编辑都用动态组件
        subtype: 'file-uploader',
        prop: 'file_path',
        rules: [{
          required: true,
          message: '请上传文件',
          trigger: 'blur'
        }],
        component: this.editType ? PreviewItem : this.isVideo && VideoUploader,
        resourceType: this.resourceType, // 传参给previewItem，根据不同的type展示不同的文件
        params: function params() {
          var acceptType = void 0,
              tip = void 0;
          switch (Number(_this2.resourceType)) {
            case 6:
              acceptType = ['mp3'];
              tip = '支持上传MP3格式的文件';
              break;
            case 10:
              // 序列帧
              acceptType = ['zip'];
              if (_this2.value.cat1_id === 1) {
                tip = '仅支持zip格式，zip包内容必须符合龙骨文件规范';
              } else if (_this2.value.cat1_id === 2) {
                tip = '仅支持zip格式，zip包中只能为图片内容';
              }
              break;
            case 11:
              // 序列帧
              acceptType = ['zip'];
              if (_this2.value.cat1_id === 1) {
                tip = '仅支持zip格式，zip包内容必须符合龙骨文件规范';
              } else if (_this2.value.cat1_id === 2) {
                tip = '仅支持zip格式，zip包中只能为图片内容';
              } else if (_this2.value.cat1_id === 3) {
                acceptType = ['jpg', 'png'];
                tip = '仅支持jpg, png格式图片';
              }
              break;
            default:
              acceptType = ['jpg', 'png', 'jpeg'];
              tip = '仅支持jpg, png, jpeg格式图片';
              break;
          }
          var temp = {
            disabled: false,
            drag: true,
            data: {
              local: 1
            },
            'with-credentials': true,
            acceptType: acceptType,
            tip: tip,
            fileList: _this2.fileList
          };

          temp.data = typeof _this2.uploadData === 'function' ? _extends({}, temp.data, _this2.uploadData(_extends({}, _this2.value))) : _extends({}, temp.data, _this2.uploadData);

          return temp;
        },
        handleUploadSuccess: this.handleUploadSuccess,
        handleRemove: this.handleRemove,
        beforeUpload: function beforeUpload(file) {
          return _this2.costomBeforeUpload(file);
        }
      }, {
        visible: this.dialogItemVisible.tag_ids,
        label: this.libName + '标签：',
        prop: 'tag_ids',
        type: 'business',
        subtype: 'tag-cascader-multi',
        rules: [{
          required: true,
          message: '请选择标签',
          trigger: 'change'
        }],
        params: {
          params: {
            type: this.resourceType
          }
        }
      }, {
        visible: this.dialogItemVisible.access_allow_pt,
        type: 'switch',
        label: '是否对外展示',
        prop: 'access_allow_pt',
        rules: [{
          required: true,
          message: '请选择是否对外展示',

          trigger: 'change'
        }],
        params: {
          activeValue: 1,
          inactiveValue: 2
        }
      }, {
        visible: this.resourceType === 14,
        type: 'component',
        component: NineGrid,
        label: '点九图',
        prop: 'ext_config',
        params: {
          handleChange: function handleChange(_ref3) {
            var value = _ref3.value,
                index = _ref3.index;

            var ext_config = {};
            try {
              ext_config = JSON.parse(_this2.value.ext_config || '{}');
            } catch (e) {
              ext_config = {};
            }
            var nine = ext_config.nine || [0, 0, 0, 0];
            nine[index] = Number(value);
            _this2.value.ext_config = _JSON$stringify(_extends({}, ext_config, { nine: nine }));
            // console.log(value, index)
          }
          // activeValue: 1,
          // inactiveValue: 2
        }
      }];
    },
    innerAnimationTag: function innerAnimationTag() {
      var key = '';
      if (this.value.cat1_id === 1) {
        key = 'approach';
      }
      if (this.value.cat1_id === 2) {
        key = 'exit';
      }
      if (this.value.cat1_id === 3) {
        key = 'stress';
      }
      return animationTag[key] || [];
    },
    filteredCat1Options: function filteredCat1Options() {
      var _this3 = this;

      return filterOption({
        list: cookOptions(this.cat1Options).filter(function (e) {
          if (_this3.isEffect) {
            return e.value !== 3;
          }
          return true;
        }),
        condition: this.optionsFilter && this.optionsFilter.cat1_id
      });
    },
    filteredCat2Options: function filteredCat2Options() {
      return filterOption({
        list: cookOptions(this.cat2Options),
        condition: this.optionsFilter && this.optionsFilter.cat2_id
      });
    }
  },
  methods: {
    show: function show(options) {
      var _this4 = this;

      // 如果是编辑操作，修改editType并且赋值form
      this.resetForm();
      if (options && options.edit) {
        this.editType = 1;
        this.$nextTick(function () {
          _this4.setForm(options.value);
        });
      } else {
        this.editType = 0;
      }
      this.config.title = this.dialogTitle;
      this.config.visible = true;
    },
    close: function close() {
      this.config.loading = false;
      this.config.visible = false;
    },
    removeLoading: function removeLoading() {
      this.config.loading = false;
    },
    resetForm: function resetForm() {
      this.value = _Object$assign(this.value, {
        id: '',
        name: '',
        name_en: '',
        file_path: '',
        message: '',
        tag_ids: [],
        cat1_id: this.filteredCat1Options && this.filteredCat1Options[0] ? this.filteredCat1Options[0].value : '',
        cat2_id: this.filteredCat2Options && this.filteredCat2Options[0] ? this.filteredCat2Options[0].value : '',
        file: {}
      });
      this.fileList = [];
    },
    setForm: function setForm(value) {
      var tagIds = [];
      if (value.tags && _.isArray(value.tags) && value.tags.length) {
        tagIds = value.tags.map(function (e) {
          return Number(e.id);
        });
      }
      this.value = _Object$assign(this.value, _extends({}, value, {
        tag_ids: tagIds,
        file_path: value.file_url
      }));
      this.oldValue = _.cloneDeep(this.value);
    },
    handleUploadSuccess: function handleUploadSuccess(response, file, fileList) {
      // 只有在上传弹框是可视的情况下才执行后续逻辑
      if (!this.config.visible) return;
      this.$emit('uploadSuccess', response, file, fileList);
      // 如果传参为true，则只执行外部event: uploadsuccess事件
      if (this.customUploadSuccess) return;
      if (response.code === 0) {
        // 新版为了方便打标签，只支持单个上传
        this.value.file_path = response.data.file_path;
        this.value.file = response.data;
      } else {
        file.status = 'fail';
        this.$message({
          message: response.msg ? response.msg : '上传失败，请重新尝试',
          type: 'warning'
        });
      }
    },

    // 处理删除资源的场景
    handleRemove: function handleRemove(file, fileList) {
      this.value.file_path = '';
      this.value.file = {};
    },
    submitDialogForm: function submitDialogForm() {
      if (_.isEqual(this.value, this.oldValue)) {
        this.close();
        return;
      }
      var dialogValue = _.cloneDeep(this.value);
      _.each(this.dialogItemVisible, function (val, key) {
        if (!val) {
          delete dialogValue[key];
        }
      });
      this.config.loading = true;
      console.log(dialogValue);
      this.$emit('submit', dialogValue);
    },
    setUploadFileList: function setUploadFileList(data) {
      this.value.file_path = data.file_path;
      this.value.file = data;
      this.fileList = [{
        name: data.origin_name,
        url: data.url
      }];
    },
    clearUploadFileList: function clearUploadFileList() {
      this.value.file_path = '';
      this.value.file = {};
      this.fileList = [];
    }
  }
};